module.exports = __webpack_public_path__ + "img/zgzpt1.f5fb5d2f.png";